import Vue from 'vue'
import VueRouter from 'vue-router'

// 页面地址

Vue.use(VueRouter)

// 路由配置
const routes = [
    {
        path: '/',
        name: '首页',
        meta: {
            title: '八点八数字-拥有数字人核心专利 提供一站式全链路解决方案 AI实时交互 AI视频 AI/XR直播 IP定制化赋能企业降本增效',
        },
        component: (resolve) => require(['@/views/index/index.vue'], resolve)
    },
    {
        path: '/yihua',
        name: '产品中心-亿话',
        meta: {
            title: '八点八数字-亿话-数字人AIGC实时交互平台 AI实时交互',
        },
        component: (resolve) => require(['@/views/yiHua/index.vue'], resolve)
    },
    {
        path: '/yiying',
        name: '产品中心-亿影',
        meta: {
            title: '八点八数字-亿影-数字人AIGC视频创作平台 快速生成AI视频',
        },
        component: (resolve) => require(['@/views/yiYing/index.vue'], resolve)
    },
    // {
    //     path: '/yibo',
    //     name: '产品中心-亿播',
    //     meta: {
    //         title: '八点八数字-亿播-数字人AIGC直播生成平台 一键AI/XR直播',
    //     },
    //     component: (resolve) => require(['@/views/yiBo/index.vue'], resolve)
    // },
    {
        path: '/jiaohu',
        name: '产品中心-交互一体机',
        meta: {
            title: '八点八数字-数字人交互一体机-开箱即用 7*24小时在线 多模态交互 垂类大模型搭配知识库',
        },
        component: (resolve) => require(['@/views/jiaoHu/index.vue'], resolve)
    },
    {
        path: '/tourism',
        name: '解决方案-数字文旅',
        meta: {
            title: '八点八数字-数字人AIGC应用一站式全链路解决方案，赋能企服展厅、展览展示文旅金融教育医疗等',
        },
        component: (resolve) => require(['@/views/tourism/index.vue'], resolve)
    },
    {
        path: '/television',
        name: '解决方案-广电融媒',
        meta: {
            title: '八点八数字-数字人AIGC应用一站式全链路解决方案，赋能企服展厅、展览展示文旅金融教育医疗等',
        },
        component: (resolve) => require(['@/views/television/index.vue'], resolve)
    },
    {
        path: '/exhibition',
        name: '解决方案-展示展览',
        meta: {
            title: '八点八数字-数字人AIGC应用一站式全链路解决方案，赋能企服展厅、展览展示文旅金融教育医疗等',
        },
        component: (resolve) => require(['@/views/exhibition/index.vue'], resolve)
    },
    {
        path: '/teacher',
        name: '解决方案-数字教师',
        meta: {
            title: '八点八数字-数字人AIGC应用一站式全链路解决方案，赋能企服展厅、展览展示文旅金融教育医疗等',
        },
        component: (resolve) => require(['@/views/teacher/index.vue'], resolve)
    },
    {
        path: '/model',
        name: '解决方案-智能终端',
        meta: {
            title: '八点八数字-数字人AIGC应用一站式全链路解决方案，赋能企服展厅、展览展示文旅金融教育医疗等',
        },
        component: (resolve) => require(['@/views/model/index.vue'], resolve)
    },
    {
        path: '/customize',
        name: '解决方案-定制服务',
        meta: {
            title: '八点八数字-数字人AIGC应用一站式全链路解决方案，赋能企服展厅、展览展示文旅金融教育医疗等',
        },
        component: (resolve) => require(['@/views/customize/index.vue'], resolve)
    },
    {
        path: '/other',
        name: '解决方案-其他行业',
        meta: {
            title: '八点八数字-数字人AIGC应用一站式全链路解决方案，赋能企服展厅、展览展示文旅金融教育医疗等',
        },
        component: (resolve) => require(['@/views/other/index.vue'], resolve)
    },
    {
        path: '/cooperation',
        name: '代理合作',
        meta: {
            title: '八点八数字-数字人应用代理商及渠道合作伙伴火热招募',
        },
        component: (resolve) => require(['@/views/cooperation/index.vue'], resolve)
    },
    {
        path: '/introduction',
        name: '关于我们-公司介绍',
        meta: {
            title: '八点八数字-国内领军数字人应用一站式全链路解决方案服务商',
        },
        component: (resolve) => require(['@/views/introduction/index.vue'], resolve)
    },
    {
        path: '/aboutUs',
        name: '关于我们-公司介绍',
        meta: {
            title: '八点八数字-国内领军数字人应用一站式全链路解决方案服务商',
        },
        component: (resolve) => require(['@/views/introduction/index.vue'], resolve)
    },
]

export default new VueRouter({
    mode: 'history',
    scrollBehavior: () => ({ y: 0 }),
    routes
});